/*** IMPORTS FROM imports-loader ***/
var define = false;

// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });

